import { render, staticRenderFns } from "./LayoutPortal.vue?vue&type=template&id=6a476840&"
import script from "./LayoutPortal.vue?vue&type=script&lang=js&"
export * from "./LayoutPortal.vue?vue&type=script&lang=js&"
import style0 from "./LayoutPortal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports